import api from './api';

const BASE_URL = '/support-tickets';

export const supportTicketsService = {
  // Get all tickets with filters
  getTickets: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/tickets`, { params });
    return response.data;
  },

  // Get single ticket with attachments
  getTicket: async (id) => {
    const response = await api.get(`${BASE_URL}/tickets/${id}`);
    return response.data;
  },

  // Create new ticket (with file uploads)
  createTicket: async (formData) => {
    const response = await api.post(`${BASE_URL}/tickets`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Update ticket
  updateTicket: async (id, data) => {
    const response = await api.put(`${BASE_URL}/tickets/${id}`, data);
    return response.data;
  },

  // Update ticket status
  updateStatus: async (id, status, resolution = null, notes = null) => {
    const response = await api.patch(`${BASE_URL}/tickets/${id}/status`, { status, resolution, notes });
    return response.data;
  },

  // Delete ticket
  deleteTicket: async (id) => {
    const response = await api.delete(`${BASE_URL}/tickets/${id}`);
    return response.data;
  },

  // Get ticket history
  getHistory: async (id) => {
    const response = await api.get(`${BASE_URL}/tickets/${id}/history`);
    return response.data;
  },

  // Get comments
  getComments: async (id) => {
    const response = await api.get(`${BASE_URL}/tickets/${id}/comments`);
    return response.data;
  },

  // Add comment
  addComment: async (id, comment) => {
    const response = await api.post(`${BASE_URL}/tickets/${id}/comments`, { comment });
    return response.data;
  },

  // Email the customer on a checkout-error ticket
  emailCustomer: async (id, { subject, body }) => {
    const response = await api.post(`${BASE_URL}/tickets/${id}/email-customer`, { subject, body });
    return response.data;
  },

  // Add attachments
  addAttachments: async (id, files) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    const response = await api.post(`${BASE_URL}/tickets/${id}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete attachment
  deleteAttachment: async (id) => {
    const response = await api.delete(`${BASE_URL}/attachments/${id}`);
    return response.data;
  },

  // Get dashboard stats
  getStats: async () => {
    const response = await api.get(`${BASE_URL}/stats`);
    return response.data;
  },

  // Get users for assignment
  getUsers: async () => {
    const response = await api.get(`${BASE_URL}/users`);
    return response.data;
  },

  // Get ticket types
  getTypes: async () => {
    const response = await api.get(`${BASE_URL}/types`);
    return response.data;
  },

  // Get statuses
  getStatuses: async () => {
    const response = await api.get(`${BASE_URL}/statuses`);
    return response.data;
  },

  // Get priorities
  getPriorities: async () => {
    const response = await api.get(`${BASE_URL}/priorities`);
    return response.data;
  }
};

export default supportTicketsService;
